import { axios } from '@/utils/request'

/**
 * 查询就诊人查询
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baPatientPage (parameter) {
  return axios({
    url: '/baPatient/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 就诊人查询列表
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baPatientList (parameter) {
  return axios({
    url: '/baPatient/detailBaPatient',
    method: 'get',
    params: parameter
  })
}


/**
 * 查询处方信息
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baRegisterList (parameter) {
  return axios({
    url: '/baPatient/registerDetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加就诊人查询
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baPatientAdd (parameter) {
  return axios({
    url: '/baPatient/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑就诊人查询
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baPatientEdit (parameter) {
  return axios({
    url: '/baPatient/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除就诊人查询
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baPatientDelete (parameter) {
  return axios({
    url: '/baPatient/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出就诊人查询
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baPatientExport (parameter) {
  return axios({
    url: '/baPatient/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
